import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { NavigationService } from 'app/core/navigation/navigation.service';

@Component({
  selector: 'app-choose-mandat',
  templateUrl: './choose-mandat.component.html',
  styleUrls: ['./choose-mandat.component.css'],
  imports: [FuseCardComponent, MatButtonModule, MatIconModule, TranslocoPipe]
})
export class ChooseMandatComponent implements OnInit {

  constructor(
    public authService: AuthService,
    private _router: Router,
    private _navigationService: NavigationService
  ) { }

  ngOnInit() {
    console.log(this.authService.mandats);
    if (this.authService.mandats.length == 1) {
      this.authService.selectMandat(this.authService.mandats[0].Id);
      this.redirectToMandat(this.authService.mandats[0].Id);
    }
  }

  redirectToMandat(mandatId: string) {
    console.log("redirecting to mandat");
    if (mandatId) {
      console.log(mandatId);
      this.authService.selectMandat(mandatId);
    }
    this.refreshNavigationAndRedirect(this.authService.getInitialRoute());
  }
  redirectToGlobal() {
    console.log("redirecting to global");
    this.authService.selectMandat(null);
    this.refreshNavigationAndRedirect(this.authService.getInitialRoute());
  }

  signOut(): void {
    this._router.navigate(['/sign-out']);
  }

  private refreshNavigationAndRedirect(url: string): void {
    this._navigationService.get().subscribe(() => {
      this._router.navigate([url]);
    });
  }
}
